'use es6';

import { Record } from 'immutable';
export default Record({
  contactId: undefined,
  hasEmail: undefined
});